<template>
  <main-header></main-header>
  <main-sidenav></main-sidenav>
  <!-- :class="{'p-0' : route.name == 'landing-page'}" -->
  <main class="container-fluid g-0 mm-bg" :class="{'p-0': ['landing-page', 'landing-page-company-register', 'personal-lading-page', 'login-page'].includes(route.name)}">
      <div class="row">
        <div class="col-12">
          <toast></toast>
          <general-loader></general-loader>
          <router-view/>
        </div>
      </div>
  </main>
  <login-modal></login-modal>
  <FirstSessionForm/>
  <SecondFormSubsequentSessions/>
  <b2b-register-modal></b2b-register-modal>
  <b2b-register-family-modal></b2b-register-family-modal>
</template>

<script>
import { defineAsyncComponent } from 'vue'
import {useRoute, useRouter} from 'vue-router';

export default {
  components: {
    MainHeader: defineAsyncComponent(() => import('@/components/HeaderV2.vue')),
    MainSidenav: defineAsyncComponent(() => import('@/components/SidenavLanding.vue')),
    GeneralLoader: defineAsyncComponent(() => import('@/components/shared/GeneralLoader.vue')),
    Toast: defineAsyncComponent(() => import('@/components/shared/Toast.vue')),
    LoginModal: defineAsyncComponent(() => import('@/modules/principal/components/LoginModal.vue')),
    FirstSessionForm: defineAsyncComponent(() => import('@/components/FirstSessionForm.vue')),
    SecondFormSubsequentSessions: defineAsyncComponent(() => import('@/components/SecondFormSubsequentSessions.vue')),
    B2bRegisterModal: defineAsyncComponent(() => import('@/components/b2bRegisterModal.vue')),
    B2bRegisterFamilyModal: defineAsyncComponent(() => import('@/components/b2bRegisterFamilyModal.vue')),
  },
  setup() {
    const route = useRoute()

    return {
      route
    }
  }
}
</script>

<style scoped>
main {
  width: 100%;
  height: 100%;
  overflow-x: hidden;
  padding-top: 62px;
  background-color: var(--mm-light);
}

main.mm-bg {
  background-color: var(--mm-main-background) !important;
}
</style>
